module.exports = __webpack_public_path__ + "static/media/diktat-8.36282553.mp3";